import { type ReactElement } from 'react'
import { Group, Text } from '@mantine/core'
import { useTranslation } from '@front/model'
import {
  PERM_GRAPH_LABEL_BACKGROUND,
  PERM_GRAPH_LABEL_COLOR,
  PERM_GRAPH_LINE_COLORS,
  PERM_GRAPH_WINNER_LABEL,
} from './permGraphVisualState'

export function PermGraphLegend(): ReactElement {
  const { t } = useTranslation()

  return (
    <Group aria-label={t('Permission graph legend')} role='note' wrap='wrap'>
      <Group gap='xs' wrap='nowrap'>
        <WinnerKey />
        <Text size='xs'>{t('source that wins')}</Text>
      </Group>
      <AccessKey color={PERM_GRAPH_LINE_COLORS.enabled} label={t('Grants access')} />
      <AccessKey color={PERM_GRAPH_LINE_COLORS.disabled} label={t('Denies access')} />
    </Group>
  )
}

function WinnerKey(): ReactElement {
  const { t } = useTranslation()

  return (
    <Text
      className='px-sm py-xs rounded-md font-semibold whitespace-nowrap'
      component='span'
      size='xs'
      style={{ background: PERM_GRAPH_LABEL_BACKGROUND, color: PERM_GRAPH_LABEL_COLOR }}
    >
      {t(PERM_GRAPH_WINNER_LABEL)}
    </Text>
  )
}

function AccessKey({ color, label }: { color: string; label: string }): ReactElement {
  return (
    <Group gap='xs' wrap='nowrap'>
      <span aria-hidden className='inline-block h-3 w-3 rounded-sm' style={{ background: color }} />
      <Text size='xs'>{label}</Text>
    </Group>
  )
}
